import { useCallback, useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import useAlerts from "./useAlerts";

function useConfirmExit(confirmExit: () => Promise<boolean>, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) {
      return;
    }

    const push = navigator.push;

    navigator.push = (...args: Parameters<typeof push>) => {
      confirmExit().then((res) => {
        if (res) {
          push(...args);
        }
      });
    };

    return () => {
      navigator.push = push;
    };
  }, [navigator, confirmExit, when]);
}

function usePrompt(
  when = true,
  message = "Are you sure you would like to leave this page?",
  description = ""
) {
  const alerts = useAlerts();

  useEffect(() => {
    if (when) {
      window.onbeforeunload = function () {
        return message;
      };
    }

    return () => {
      window.onbeforeunload = null;
    };
  }, [message, when]);

  const confirmExit = useCallback(async () => {
    const confirmed = await alerts.confirm(message, description);
    alerts.close();
    return confirmed;
  }, [message, alerts, description]);

  useConfirmExit(confirmExit, when);
}

export default usePrompt;
